import '../css/FloatingBanner.css';
import { useState, useEffect } from 'react';
import { Flex } from 'antd';
import { useQuery } from "@apollo/client";
import { GET_FLOATING_BANNER } from "../queries";
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorage";
import setImageAbsoluteUrl from "../utils/setImageAbosulteUrl";
import { useLoading } from "../utils/ApolloProvider";

const MediaItem = ({ slug, page, isLoading }) => {
  const [item, setItem] = useState(() => {
    const cachedData = getFromLocalStorage(page);
    return cachedData?.media?.[slug] || null;
  });

  const { loading, error } = useQuery(GET_FLOATING_BANNER, {
    variables: { slug },
    skip: !!item,
    onCompleted: (fetchedData) => {
      
      const bannerData = fetchedData.sectionsBy?.floatingBanner;
      const dataToLocal = {
        ...item,
        media: {
          [slug]: bannerData,
        },
      }
      saveToLocalStorage(page, dataToLocal);
      setItem(bannerData);
    },
  });
  
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const transitionTime = parseFloat(item?.transition) * 1000 || 3000;
    const timer = setTimeout(() => {
      setVisible(false);
    }, transitionTime);
    return () => clearTimeout(timer);
  }, [item?.transition]);
  
  return (
    !isLoading && item?.bannerImage?.node?.mediaItemUrl && (
      <img 
      loading="lazy"
      style={{
        position: 'fixed',
        top: '150px',
        transition: `left ${item.transition} ease, right ${item.transition} ease, opacity ${item.transition} ease`,
        ...(item.position === "Left"
            ? { left: visible ? "0px" : "-250px", opacity: visible ? 1 : 0 }
            : { right: visible ? "0px" : "-250px", opacity: visible ? 1 : 0 })
      }}
      alt={(item?.bannerImage?.node?.altText || item?.bannerImage?.node?.title) || "Placeholder"} src={setImageAbsoluteUrl(item?.bannerImage?.node?.mediaItemUrl) || "placeholder.png"} />
    )
  );
};

const FloatingBanner = ({ page, section, lang }) => {
  const slug = `${page}-${section}-${lang}`;
  const isLoading = useLoading();

  return (
    <>
      <Flex className="FloatingBanner">
        <MediaItem slug={slug} page={page} isLoading={isLoading} />
      </Flex>
    </>
  );
};

export default FloatingBanner;
